import PropTypes from 'prop-types';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import WalletRowContainer from './WalletRowContainer';
import { DepositReferenceIdModalContainer } from 'apex-web/lib/components/Retail/RetailSidePanes/FiatDeposit';
import Spinner from 'apex-web/lib/components/common/Spinner/Spinner';

import 'apex-web/lib/components/WalletRows/WalletRowList.css';

const walletRowListClasses = getBEMClasses('wallet-row-list');

const WalletRowListComponent = (props, context) => {
  if (props.fetching) {
    return <Spinner customClass={walletRowListClasses} />;
  }

  const items = props.products.map(item => {
    return (
      <WalletRowContainer
        key={item.ProductId}
        productId={item.ProductId}
        detailsLink={props.detailsLink}
      />
    );
  });

  return (
    <div className={walletRowListClasses()}>
      {items}
      <DepositReferenceIdModalContainer />
    </div>
  );
};

WalletRowListComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default WalletRowListComponent;
